import { callRoomIdFromThreadKey as coreCallRoomIdFromThreadKey, isThreadId } from "@/core_bridge/module_api";

export function callRoomIdFromThreadKey(threadKey: string): string {
  return coreCallRoomIdFromThreadKey(threadKey);
}

export function resolveCallRoomId(value: string): string {
  const trimmed = (value || "").trim();
  if (!trimmed) return trimmed;
  return isThreadId(trimmed) ? callRoomIdFromThreadKey(trimmed) : trimmed;
}
